import EvidenceButton from './EvidenceButton';

export default EvidenceButton;
